import {apiClient} from 'core/apiClient';
import {Participant} from 'types/participants';
import {StaffListRawRow, StaffPaginationContent} from 'types/profile';

const URL = 'uaa/web';

export async function fetchPagedStaffList(params: {
    pageNumber: number;
    pageSize: number;
}): Promise<StaffPaginationContent<StaffListRawRow>> {
    const offset = params.pageSize * params.pageNumber;
    const limit = params.pageSize;

    return (
        await apiClient.get<StaffPaginationContent<StaffListRawRow>>(`${URL}/employees/paged`, {
            params: {offset, limit},
        })
    ).data;
}

export async function fetchStaffList(): Promise<StaffListRawRow[]> {
    return (await apiClient.get<StaffListRawRow[]>(`${URL}/employees`)).data;
}

export async function fetchParticipantList() {
    return (await apiClient.get<Participant[]>(`uaa/clients`)).data;
}
